module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.configurator !== null) ? _c('div', {
    attrs: {
      "id": "instructions"
    }
  }, [_c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(_vm.isGalleryVisible) ? _c('projectsgallery', {
    on: {
      "close": function($event) {
        _vm.isGalleryVisible = false
      },
      "projectselected": _vm.projectSelected
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "goback upcase h7 regular c-dgrey",
    on: {
      "click": _vm.goToChooseConf
    }
  }, [_c('span', {
    staticClass: "goback_arrow"
  }, [_vm._v("<")]), _vm._v(_vm._s(_vm.$t('back')) + "\n\t\t")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h2', {
    staticClass: "h2 medium c-dark upcase"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.configurator == 'k1_wall' ? 'k1' : _vm.configurator) + "\n\t\t\t\t"), _c('span', {
    staticClass: "light"
  }, [_vm._v("System")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    directives: [{
      name: "nlbr",
      rawName: "v-nlbr",
      value: (_vm.$t((_vm.configurator + "_instructions"))),
      expression: "$t(`${configurator}_instructions`)"
    }],
    staticClass: "h6 light c-dark"
  }), _vm._v(" "), (_vm.configurator === 'k1' || _vm.configurator === 'k1_wall') ? _c('div', {
    staticClass: "k1_configuration"
  }, [_c('div', {
    staticClass: "k1_configuration_text"
  }, [_c('span', {
    staticClass: "h5 medium c-dark"
  }, [_vm._v(_vm._s(_vm.$t('montanti')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "h7 c-dgrey regular"
  }, [_vm._v(_vm._s(_vm.$t('k1_terra')))])]), _vm._v(" "), _c('check-element', {
    attrs: {
      "invert": false,
      "initialvalue": _vm.configurator !== 'k1_wall',
      "imagebig": true,
      "trueimage": "/images/k1-parete.svg",
      "labeltrue": _vm.$t('k1_suspended_type_name'),
      "labelfalse": _vm.$t('k1_ground_type_name'),
      "falseimage": "/images/k1-terra.svg"
    },
    on: {
      "change": _vm.toggleK1Type
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "light c-accent h6 nextview_btn",
    on: {
      "click": function($event) {
        _vm.isGalleryVisible = true
      }
    }
  }, [(_vm.loggedIn) ? _c('span', {
    staticClass: "underline"
  }, [_vm._v("I tuoi progetti")]) : _vm._e(), (!_vm.loggedIn) ? _c('span', {
    staticClass: "underline"
  }, [_vm._v("Gallery")]) : _vm._e(), _vm._v(" >\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "light c-accent h6 nextview_btn",
    on: {
      "click": _vm.openVideo
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Video tutorial")]), _vm._v(" >\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "light c-accent h6 nextview_btn",
    on: {
      "click": _vm.nextView
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v(_vm._s(_vm.$t('startconfiguration')))]), _vm._v(" >\n\t\t\t")])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08489b0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/views/Instructions.vue
// module id = 618
// module chunks = 0